import {
  GET_PARCELS,
  UPDATE_PARCELS,
  CREATE_PARCELS,
  UPDATE_PARCELS_STATUS,
  GET_PARCELS_WITH_ID,
  DELETE_PARCEL,
  GET_LOGS,
  CANCEL_PARCEL,
  UPDATE_PARCEL_OPERATOR,
  GET_PARCEL_INVENTORY_ITEMS,
  UPDATE_INVENTORY_ITEMS,
  GET_INVENTORY_ITEMS_WITH_SERIAL,
  GET_INVENTORY_ITEMS_WITH_STATUS,
  UPDATE_INVENTORY_ITEMS_UNIT,
  UPDATE_PARCEL_ITEMS_UNIT,
  CLEAN_PARCEL_INVENTORY_ITEMS,
  UPDATE_ALL_INVENTORY_ITEMS_UNIT,
  UPDATE_INVENTORY_ITEMS_CHECKED,
  RELOCATE_BY_ITEM, UPDATE_MULTI_INVENTORY_ITEMS_STATUS,
  GET_RONAD_PARCELS_WITH_ID,
  DELETE_PARCEL_ITEMS, CREATE_PARCEL_ITEMS, GET_ALL_PARCELS_REPORT,
} from './constants';
import {PayloadUpdate, PayloadCreate, multiStatusBody} from './interfaces';
import {RelocateAction} from '../relocate/byItem/interface';
import {Payload} from '../orders/interfaces';

export function getParcelsAction(payload: Record<string, any>) {
  return {
    type: GET_PARCELS,
    payload,
  };
}

export function getParcelInventoryItemsAction(payload: Record<string, any>) {
  return {
    type: GET_PARCEL_INVENTORY_ITEMS,
    payload,
  };
}

export function getAllParcelsReportAction(payload: Payload) {
  return {
    type: GET_ALL_PARCELS_REPORT,
    payload,
  };
}

export function getInventoryItemsWithSerialAction(
  payload: Record<string, any>
) {
  return {
    type: GET_INVENTORY_ITEMS_WITH_SERIAL,
    payload,
  };
}

export function getInventoryItemsWithStatusAction(
  payload: Record<string, any>
) {
  return {
    type: GET_INVENTORY_ITEMS_WITH_STATUS,
    payload,
  };
}

export function updateParcelsActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_PARCELS,
    payload,
  };
}

export function updateInventoryItemsActions(payload: Record<string, any>) {
  return {
    type: UPDATE_INVENTORY_ITEMS,
    payload,
  };
}

export function deleteParcelItemsActions(payload: Object) {
  return {
    type: DELETE_PARCEL_ITEMS,
    payload,
  };
}

export function updateInventoryItemsCheckedActions(
  payload: Record<string, any>
) {
  return {
    type: UPDATE_INVENTORY_ITEMS_CHECKED,
    payload,
  };
}

export function locateInventoryItemsUnitActions(payload: Record<string, any>) {
  return {
    type: UPDATE_INVENTORY_ITEMS_UNIT,
    payload,
  };
}

export function locateAllInventoryItemsUnitActions(
  payload: Record<string, any>
) {
  return {
    type: UPDATE_ALL_INVENTORY_ITEMS_UNIT,
    payload,
  };
}

export function updateParcelItemsUnitActions(payload: Record<string, any>) {
  return {
    type: UPDATE_PARCEL_ITEMS_UNIT,
    payload,
  };
}

export function updateParcelOperatorActions(payload: Record<string, any>) {
  return {
    type: UPDATE_PARCEL_OPERATOR,
    payload,
  };
}

export function createParcelsActions(payload: PayloadCreate) {
  return {
    type: CREATE_PARCELS,
    payload,
  };
}

export function createParcelItemsActions(payload: Object) {
  return {
    type: CREATE_PARCEL_ITEMS,
    payload,
  };
}

export function updateParcelsStatusActions(payload: {
  id: number;
  body: object;
  pagination: object;
  callback?: () => void;
}) {
  return {
    type: UPDATE_PARCELS_STATUS,
    payload,
  };
}

export function getParcelsWithIdAction(payload: {id: number}) {
  return {
    type: GET_PARCELS_WITH_ID,
    payload,
  };
}

export function getRonadParcelsWithIdAction(payload: {id: number}) {
  return {
    type: GET_RONAD_PARCELS_WITH_ID,
    payload,
  };
}

export function deleteParcelAction(payload: {id: number}) {
  return {
    type: DELETE_PARCEL,
    payload,
  };
}

export function getLogsAction(payload: {id: number}) {
  return {
    type: GET_LOGS,
    payload,
  };
}

export function cancelParcelAction(payload: {id: number}) {
  return {
    type: CANCEL_PARCEL,
    payload,
  };
}

export function cleanPercelInventoryItemsAction() {
  return {
    type: CLEAN_PARCEL_INVENTORY_ITEMS,
  };
}

export function relocateByItemAction(payload: RelocateAction) {
  return {
    type: RELOCATE_BY_ITEM,
    payload,
  };
}

export function updateMultiInventoryItemsStatusAction(payload: multiStatusBody) {
  return {
    type: UPDATE_MULTI_INVENTORY_ITEMS_STATUS,
    payload,
  };
}
